import axios from "./axiosInstance";
import {
  SupplierApiResponse,
  SupplierDetailsApiResponse,
  SupplierCreatePayload,
  SupplierUpdatePayload,
  SupplierSearchParams,
  PaginatedSupplierApiResponse
} from "../types/suppliersTypes";

/**
 * Create a new supplier
 */
export const createSupplier = async (payload: SupplierCreatePayload): Promise<SupplierApiResponse> => {
  const response = await axios.post<SupplierApiResponse>("/suppliers", payload);
  return response.data;
};

/**
 * Search suppliers with optional parameters
 */
export const getAllSuppliers = async (params: SupplierSearchParams): Promise<PaginatedSupplierApiResponse> => {
  const response = await axios.get<PaginatedSupplierApiResponse>("/suppliers", { params: { ...params , page: 1, limit: 10000 } });
  return response.data;
};

/**
 * Fetch a specific supplier by ID
 */
export const getSupplierById = async (supplierId: string): Promise<SupplierDetailsApiResponse> => {
  const response = await axios.get<SupplierDetailsApiResponse>(`/suppliers/${supplierId}`);
  return response.data;
};

/**
 * Update an existing supplier
 */
export const updateSupplier = async (supplierId: string, payload: SupplierUpdatePayload): Promise<SupplierApiResponse> => {
  const response = await axios.put<SupplierApiResponse>(`/suppliers/${supplierId}`, payload);
  return response.data;
};

/**
 * Delete a supplier
 */
export const deleteSupplier = async (supplierId: string): Promise<SupplierApiResponse> => {
  const response = await axios.delete<SupplierApiResponse>(`/suppliers/${supplierId}`);
  return response.data;
};